import React from 'react'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded'

import BoilerCard from '../boiler-card'
import { useAppliances } from '../../hooks/use-appliance'

function ApplianceList({
    estateId,
} : {
    estateId: string | undefined,
}) {

    const { status, data, error } = useAppliances(estateId)

    if (status === 'pending') {
        return (
            <CircularProgress />
        )
    }

    if (error) {
        return (
            <Box>
                <ErrorOutlineRoundedIcon />
                <Box>{error.message}</Box>
            </Box>
        )
    }

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1.5,
        }}>
            {data.map((appliance, index) => (
                <BoilerCard
                    key={index}    
                    appliance={appliance}
                />
            ))}
        </Box>
    )
}

export default ApplianceList
